































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { currencyKeyboardEventValidation } from '@/util/CurrencyValidation';
import { Getter } from 'vuex-class';
import location from '@/store/types/location';
import { StateParams } from '@/store/interfaces/state';
import { EnterpriceCommissions } from '@/store/interfaces/company';
import commissionForm from '@/components/Company/newCompany/companyInfo/forms/commissions.vue';
import HttpComponentRequest from '@/util/classes/httpComponentRequest';
import { IqueryUrl } from '@/store/interfaces/generic';
import { CommerceParams } from '@/store/interfaces/commerce';
import { DraftCompanyParams } from '@/store/interfaces/drafts';

type valueName = {
  name: string;
  value: string;
};

@Component({
  components: { commissionForm, },
})
export default class ProfileInboundForm extends Vue {
  @Prop({
    required: true,
    type: Object,
    default: () => ({}),
  })
  draft!: DraftCompanyParams;

  commerces = new HttpComponentRequest<CommerceParams>();
  isLoadingMoreCommerce = false;
  commerceData: CommerceParams[] = [];
  profile = {
    line: '',
    commerce_id: '',
    address_municipality: '',
    name: '',
    company_kind: 'natural',
    address_state_code: '',
    taxpayer_type: '',
    address_summary: '',
    address: {
      description: '',
      phone: '',
    },
  };

  commissions: EnterpriceCommissions = {
    rate: 0,
    start_at: '',
    liquidation_period: '',
    minimum_order_value: 0,
    renewal: 'automatic',
  };

  taxpayer_array: valueName[] = [
    {
      name: 'No contribuyente',
      value: 'non',
    },
    {
      name: 'Pequeño',
      value: 'small',
    },
    {
      name: 'Mediano',
      value: 'medium',
    },
    {
      name: 'Grande',
      value: 'big',
    },
    {
      name: 'Gubernamental',
      value: 'governmental',
    },
    {
      name: 'Otro',
      value: 'other',
    }
  ];

  type_artificial_person_array: valueName[] = [
    {
      name: 'Natural',
      value: 'natural',
    },
    {
      name: 'Jurídica',
      value: 'legal',
    }
  ];

  currencyKeyboardEventValidation = currencyKeyboardEventValidation;

  async getCommercesFromServer({ url, }: IqueryUrl): Promise<void> {
    this.isLoadingMoreCommerce = true;
    this.commerces
      .getHttpRequest(url)
      .then(() => {
        this.commerceData = this.commerces.getData;
      })
      .finally(() => {
        this.isLoadingMoreCommerce = false;
      });
  }

  @Watch('draft', { deep: true, immediate: true, })
  onDraftChange(df: DraftCompanyParams): void {
    this.assignValueToProfile(df);
  }

  assignValueToProfile(df: DraftCompanyParams): void {
    this.profile.line = df.line;
    this.profile.name = df.name;
    this.profile.company_kind = df.company_kind;
    this.profile.address_state_code = df.address_state_code;
    this.profile.address_municipality = df.address_municipality;
    this.profile.address_summary = df.address_summary;
  }

  updateInboundProfile(): void {
    console.log('hola');
  }

  @Getter(`country/${location.getters.GET_STATE}`)
  getListState!: StateParams[];
}
